import type { HdcReport } from "../../../../../ExperianPrivateResponse.types";
import { LiabilityRowVM, mapLiabilities } from "../mappers";
import { C, tabular } from "../theme";
import { Card } from "../shared/Card";
import { Column, DataTable } from "../shared/DataTable";
import { StatusPill } from "../shared/StatusPill";
import { BehaviourVector, VectorLegend } from "../shared/BehaviourVector";

const columns: Column<LiabilityRowVM>[] = [
  { key: "entity", header: "Entidad", align: "l", strong: true, render: (o) => o.entity },
  { key: "type", header: "Tipo", render: (o) => o.type },
  { key: "account", header: "Cuenta", render: (o) => o.account, cellStyle: () => tabular },
  { key: "debtor", header: "Calidad", render: (o) => o.debtor },
  { key: "status", header: "Estado", render: (o) => <StatusPill {...o.status} /> },
  { key: "opened", header: "Apertura", render: (o) => o.opened },
  { key: "initial", header: "Valor inicial", align: "r", render: (o) => o.initial },
  {
    key: "balance",
    header: "Saldo",
    align: "r",
    render: (o) => o.balance,
    cellStyle: () => ({ color: C.white }),
  },
  {
    key: "overdue",
    header: "Mora",
    align: "r",
    render: (o) => o.overdue,
    cellStyle: (o) => (o.hasOverdue ? { color: C.bad, fontWeight: 600 } : undefined),
  },
  { key: "quota", header: "Cuota", align: "r", render: (o) => o.quota },
  { key: "installments", header: "Cuotas", render: (o) => o.installments },
  {
    key: "rating",
    header: "Calif.",
    render: (o) => o.rating,
    cellStyle: () => ({ fontWeight: 700 }),
  },
  {
    key: "vector",
    header: "Comportamiento",
    align: "l",
    render: (o) => <BehaviourVector cells={o.vector} />,
  },
];

export const ObligacionesTab = ({ report }: { report: HdcReport }) => (
  <Card
    flush
    title="Obligaciones (cartera)"
    aside={<VectorLegend caption="Vector 24 meses, más reciente a la izquierda:" />}
  >
    <DataTable
      caption="Obligaciones (cartera)"
      columns={columns}
      rows={mapLiabilities(report)}
    />
  </Card>
);
